export interface IFileMetadataProperties {
  name: string;
  contentType: string;
}
